import { useState, useEffect } from 'react';
import supabase from '../lib/supabase';

const FREE_LIMIT = 5;

function today() {
  return new Date().toISOString().split('T')[0];
}

export function useFreemium(user) {
  const [isPremium, setIsPremium] = useState(false);
  const [used, setUsed] = useState(0);

  useEffect(() => {
    if (!user) return;
    supabase
      .from('profiles')
      .select('is_premium, daily_questions_date, daily_questions_count')
      .eq('id', user.id)
      .single()
      .then(({ data }) => {
        if (data?.is_premium) {
          setIsPremium(true);
        } else {
          const sameDay = data?.daily_questions_date === today();
          setUsed(sameDay ? (data?.daily_questions_count ?? 0) : 0);
        }
      });
  }, [user]);

  const questionsLeft = isPremium ? Infinity : Math.max(0, FREE_LIMIT - used);
  const canAsk = isPremium || used < FREE_LIMIT;

  // Still increment locally for immediate UI feedback — server enforces the real limit
  function consumeQuestion() {
    if (isPremium) return;
    setUsed(u => u + 1);
  }

  return { isPremium, questionsLeft, canAsk, consumeQuestion };
}
